module.exports = __webpack_public_path__ + "img/person_black_24dp.f03c94b7.svg";